import React, { useState, useEffect } from "react";
import { Stack, Box, Typography, useMediaQuery } from "@mui/material";
import {
  BannerSection,
  BestElectronics,
  BestSellers,
  NearByShops,
  PopularSearches,
} from "../../components";
import { CategoriesCarousel } from "../../components/Categories/categoriesCarousel";

import Header from "../../components/Header/userHeader";
import { UserFooter } from "../../components";
import TrendindNow from "../../components/TrendingNow/TrendingNow";
import ScrollToTopButton from "../../components/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";
import { getAppToken } from "../../store/actions/userActions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const BannerImage = ({ index, data }) => {
  const banner = data[index];
  return banner?.image_url ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        component="img"
        src={banner.image_url}
        alt={`Banner ${index}`}
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", md: 1280 },
          width: "100%",
          height: "auto",
          maxHeight: "235px",
          objectFit: "cover",
          margin: { xs: 2, sm: 3, md: 4 },
          cursor: "pointer",
        }}
      />
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "90%",
        height: "100px",
        margin: { xs: 2, sm: 3, md: 4 },
        border: "1px solid #90caf9",
        borderRadius: 2,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
        alignSelf: "center",
        gap: 1.5,
        px: 2,
      }}
    >
      <InfoOutlinedIcon sx={{ color: "#1976d2" }} />
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", color: "#1976d2" }}
      >
        No banners to display
      </Typography>
    </Box>
  );
};

const Home = () => {
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const apptoken = useSelector((state) => state.user.apptoken);

  const {
    data: bannersData,
    isLoading: isBannersLoading,
    error,
    fetchData: fetchBannersData,
  } = useFetch(BASE_URL_TEST + urls("getAllBanners"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (apptoken) {
      fetchBannersData();
    }
  }, [apptoken]);

  useEffect(() => {
    if (error) {
      console.warn("Failed to fetch banners");
    } else if (bannersData?.status === true) {
      setData(bannersData["data"] || []);
    }
  }, [bannersData, error]);

  return (
    <Stack
      spacing={isSmallScreen ? 2 : 4}
      sx={{
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Header />
      {/* <BannerSection /> */}
      <CategoriesCarousel />

      {/* <BannerImage index={4} data={data} /> */}
      <NearByShops />
      {/* <BannerImage index={3} data={data} /> */}
      {/* <BestSellers /> */}
      {/* <BannerImage index={2} data={data} /> */}
      {/* <TrendindNow /> */}
      {/* <BannerImage index={1} data={data} /> */}
      {/* <BestElectronics /> */}
      <PopularSearches />
      {/* <BannerImage index={0} data={data} /> */}
      <UserFooter />
      <ScrollToTopButton />
    </Stack>
  );
};

export default Home;
